<template>
  <div class="talk-theme-view">
    <div class="text">
      {{ 'お題: ' + text }}
    </div>
    <div class="">
      ※ 議論を開始してください。
    </div>
  </div>
</template>
<script>
export default {
  name: 'TalkThemeView',
  props: {
    text: String
  }
}
</script>
<style scoped>
.text {
  font-size: 50px;
}
</style>
